import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { SupervisionIntegrationPage } from "./ui";

export const SupervisionIntegrationPageRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.supervision.integrationSettings(":projectId", ":supervisionId")}`,
    element: createElement(SupervisionIntegrationPage),
    children: [...rest],
  };
};
